import {
  validateInstagramCarouselComposition,
  type InstagramCarouselValidationResult,
} from '@mondaygpt/constants'
import type { InstagramMediaItem } from '../types'

export type CarouselValidationResult = InstagramCarouselValidationResult

/**
 * Client preflight wrapper around the shared carousel validator.
 *
 * Always runs the shared validator. When an item is missing ratio/mimeType
 * metadata, the validator returns its own actionable error ("missing aspect
 * ratio. Re-upload the image."), which Publish surfaces inline. Previously
 * this wrapper short-circuited to `{ ok: true }` when metadata was missing,
 * letting users press Publish on invalid carousels and get rejected by the
 * Instagram Graph API (`carousel_aspect_mismatch`).
 */
export function validateInstagramCarousel(items: InstagramMediaItem[]): CarouselValidationResult {
  return validateInstagramCarouselComposition(
    items.map(item => ({ ratio: item.ratio ?? null, mimeType: item.mimeType ?? null }))
  )
}
